module.exports = __webpack_public_path__ + "static/media/black-board.42befa60.svg";